import React from 'react';
import { ShapeSectionOptions } from '../ShapePanel/ShapePanel';
import { SharedSpotPanelControls } from './SharedSpotPanelControls';

export const SpotPanelControls: React.FC<ShapeSectionOptions> = (props) => {
  return (
    <>
      <SharedSpotPanelControls {...props} isSpotGroup />
    </>
  );
};
